// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wt-z","tooltipWrapper":"xt-z","icon":"yt-z","tooltip":"zt-z","content":"At-z"};